import { render, staticRenderFns } from "./VirtualAccountFreightBillTax.vue?vue&type=template&id=01d12b07&scoped=true"
import script from "./VirtualAccountFreightBillTax.vue?vue&type=script&lang=js"
export * from "./VirtualAccountFreightBillTax.vue?vue&type=script&lang=js"
import style0 from "./VirtualAccountFreightBillTax.vue?vue&type=style&index=0&id=01d12b07&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d12b07",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01d12b07')) {
      api.createRecord('01d12b07', component.options)
    } else {
      api.reload('01d12b07', component.options)
    }
    module.hot.accept("./VirtualAccountFreightBillTax.vue?vue&type=template&id=01d12b07&scoped=true", function () {
      api.rerender('01d12b07', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/VirtualAccountFreightBillTax.vue"
export default component.exports